import appconfig from '@/utils/appConfig';
import clsx from 'clsx';
import { ReactNode } from 'react';

interface FullWidthContainerProps {
    children: ReactNode;
    light?: boolean;
    dark?: boolean;
    className?: string;
}

const FullWidthContainer = ({
    className,
    light = false,
    dark = false,
    children,
}: FullWidthContainerProps) => {
    let colorClass;
    switch (true) {
        case light:
            colorClass = 'bg-white';
            break;
        case dark:
            colorClass = appconfig.colors.coloredSection;
            break;
        default:
            colorClass = appconfig.colors.coloredSectionlight;
            break;
    }
    const fwcClasses = clsx(
        'w-full',
        colorClass,
        'flex',
        'flex-col',
        'justify-center',
        className || ''
    );

    return <div className={fwcClasses}>{children}</div>;
};

export default FullWidthContainer;
